// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Borna_a32782', '__Borna_Fallback_a32782'"},"className":"__className_a32782"};